import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import {
  Checkbox,
} from '.';

const automationTypes = {
  BOT: 'bot',
  KB: 'kb',
};

const textColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.greyMiddle,
});

const menuTextColor = theme('mode', {
  light: (props) => props.theme.colors.brightCerulean,
  dark: (props) => props.theme.colors.brightCerulean,
});

const HeaderStyled = styled(Flex)`
  text-transform: uppercase;
  color: ${textColor};
  font-size: 13px;
  line-height: 1.3;
  max-width: 900px;
  max-width: 914px;
  padding: 9px 16px;
`;

const SelectedMenu = styled(Flex)`
  font-size: 13px;
  font-weight: 700;
  margin-left: 0;
`;

const SelectedCounter = styled(Flex)`
  text-transform: lowercase;
  margin-left: 5px;
  margin-right: 54px;
  & span {
    margin-left: 5px;
  }
`;

const StyledButton = styled(Flex)`
  margin-right: 24px;
  text-transform: none;
  color: ${menuTextColor};
  cursor: pointer;
`;

const CheckBoxWrapper = styled(Flex)`
  margin-right: 40px;
  &.selected {
    margin-right: 8px;
  }
`;

const TitleWrapper = styled(Flex)`
  width: calc(100% - 20px);
`;

function AutomationListMenu(props) {
  const {
    onSelectAllChange,
    selectedAll,
    selectedAutomations,
    automationType,
    onUpdateAutomationCredentials,
    onEnableAutomations,
    onRemoveSkills,
    onAddSkills,
  } = props;

  function getAutomationTitle() {
    return automationType === automationTypes.KB
      ? 'Knowledge bases'
      : 'BOTS';
  }

  function getEnableButtonTitle() {
    return automationType === automationTypes.KB
      ? ' knowledge base'
      : ' bot';
  }

  function getAutomationSkillsTitle() {
    return 'associated SKILLS';
  }

  return (
    <HeaderStyled flexDirection="row" mb="16px" alignItems="center">
      <Flex width="100%">

        {selectedAutomations.length
          ? (
            <SelectedMenu>
              <CheckBoxWrapper className="selected">
                <Checkbox
                  checked={selectedAll}
                  onChange={onSelectAllChange}
                />
              </CheckBoxWrapper>
              <SelectedCounter>
                (
                {selectedAutomations.length}
                <span>selected</span>
                )
              </SelectedCounter>
              <Flex>
                {automationType === automationTypes.BOT && (
                  <StyledButton
                    onClick={onUpdateAutomationCredentials}
                  >
                    Update user credentials
                  </StyledButton>
                )}

                <StyledButton
                  onClick={() => onEnableAutomations(true)}
                >
                  Enable
                  {getEnableButtonTitle()}
                </StyledButton>
                <StyledButton
                  onClick={() => onEnableAutomations(false)}
                >
                  Disable
                  {getEnableButtonTitle()}
                </StyledButton>
                <StyledButton
                  onClick={onAddSkills}
                >
                  Add all available skills
                </StyledButton>
                <StyledButton
                  onClick={onRemoveSkills}
                >
                  Remove all skills
                </StyledButton>
              </Flex>
            </SelectedMenu>
          )
          : (
            <TitleWrapper>
              <CheckBoxWrapper>
                <Checkbox
                  checked={selectedAll}
                  onChange={onSelectAllChange}
                />
              </CheckBoxWrapper>
              <Box width={['100%', '40%', '18%']}>
                Status
              </Box>
              <Box width={['100%', '50%', '30%']}>
                {getAutomationTitle()}
              </Box>
              <Box width={['90%', '90%', '52%']} maxWidth="400px">
                {getAutomationSkillsTitle()}
              </Box>
            </TitleWrapper>
          )}
      </Flex>
    </HeaderStyled>
  );
}

AutomationListMenu.defaultProps = {
  automationType: 'bot',
};

AutomationListMenu.propTypes = {
  onSelectAllChange: PropTypes.func.isRequired,
  selectedAll: PropTypes.bool.isRequired,
  selectedAutomations: PropTypes.array.isRequired,
  automationType: PropTypes.string,
  onUpdateAutomationCredentials: PropTypes.func.isRequired,
  onEnableAutomations: PropTypes.func.isRequired,
  onRemoveSkills: PropTypes.func.isRequired,
  onAddSkills: PropTypes.func.isRequired,
};

export default AutomationListMenu;
